import { AlertModal } from '@modusign/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useMount } from 'react-use';

import { useUrlQuery } from '@hooks';
import LoadingStatus from '@libs/loading-status';
import { wwwServiceUrl } from '@libs/serviceUrls';

import RootLoadingSpinnerComponent from '@app/components/Loading/RootLoadingSpinnerComponent';
import {
  fetchEmbeddedDocumentRequest,
  getError,
  getLoadingStatus,
  setError,
} from '@app/features/integration/embeddedDocument/state';
import embeddedService, { EmbeddedServiceError } from '@app/libs/embedded/embeddedService';
import redirect from '@app/libs/embedded/redirect';
import { logger } from '@app/libs/logger';

export default function EmbeddedViewer() {
  const query = useUrlQuery();
  const dispatch = useDispatch();

  const { documentId } = useParams<{ documentId: string }>();
  const error = useSelector(getError);

  const loadingStatus = useSelector(getLoadingStatus);

  useMount(() => {
    if (!embeddedService.isEmbedded) {
      return;
    }

    switch (embeddedService.error) {
      case null:
        dispatch(
          fetchEmbeddedDocumentRequest({
            documentId,
            signable: query.get('signable') === 'true',
          })
        );
        break;
      case EmbeddedServiceError.EXPIRED_ACCESS_TOKEN:
        dispatch(
          setError({
            title: '만료된 URL',
            content: 'URL이 만료되었습니다.\n다시 발급해 주세요.',
          })
        );
        break;
      default:
        logger.error(`embedded service error occurred in embedded document page.`, {
          documentId,
          error: embeddedService.error,
        });
        dispatch(
          setError({
            title: '유효하지 않은 접근',
            content: '유효하지 않은 접근입니다.',
          })
        );
    }
  });

  return (
    <div className="align-center">
      {error && (
        <AlertModal
          isOpen
          maxWidth="xxs"
          title={error.title ?? ''}
          variant="warning"
          onClose={() => redirect(wwwServiceUrl)}
        >
          {error.content}
        </AlertModal>
      )}
      <RootLoadingSpinnerComponent isLoading={loadingStatus === LoadingStatus.PENDING} isOverlay />
    </div>
  );
}
